
import React, { useState, useEffect, useRef  } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import Lottie from "react-lottie-player";
import { getDatabase, ref, get, onValue, update } from "firebase/database";
import app from "../../../firebaseConfig";

import rayoazul from './assets/lottie/rayoazul.json';

import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import { motion } from "framer-motion"; // Importamos framer-motion

import Alertadenegado from "../alertadenegado"; // Ajusta la ruta según tu estructura
import { FaBars, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";

import { cacheImage } from "../../../utils/cacheImage";

import "react-toastify/dist/ReactToastify.css";
import VisorProducto from './VisorProducto';
import ResenasProducto from './resenasproducto'; 
import ResumenResenas from "./ResumenResenas";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";


function PantallaPrincipal() {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const location = useLocation();
  const navigate = useNavigate(); // Inicializamos navigate
  const { mesa} = location.state || {};
  const { categoria, producto: slugParam } = useParams(); // tu ruta es /:categoria/:producto -> producto es el slug/id
 
  // producto enviado por state (cuando navegas desde Inicio)
  const productoState = location.state?.producto || null;
  const [producto, setProducto] = useState(productoState);

    // Normalizar valores
    const categoriaid = producto?.categoria || producto?.Categoria || categoria || "";
    const productoid = productoState ? (productoState.id ? String(productoState.id) : slugify(productoState.Titulo || productoState.titulo)) : decodeURIComponent(slugParam || "");
  

    console.log(categoriaid+productoid+productoState);



  const [activeCategory, setActiveCategory] = useState(null);
  const [categorias, setCategorias] = useState([]);
  
  const categoryRefs = useRef({});
  const categoriasRef = useRef(null);

  const [productos, setProductos] = useState([]);

    const [mostrarBusqueda, setMostrarBusqueda] = useState(false);
  
    const toggleBusqueda = () => {
      setMostrarBusqueda(!mostrarBusqueda);
    };

    const [menuAbierto, setMenuAbierto] = useState(false);

      // helper para generar ids/keys sin espacios
const slugify = (str) =>
  String(str)
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]/g, "");


  const handleCategoriaClick = (categoriaNombre) => {
    const slug = slugify(categoriaNombre);
    const el = categoryRefs.current[slug] || document.getElementById(`cat-${slug}`);
    if (!el) return;
  
    // intentar detectar el header/top nav si existe (ajusta selector si tu nav tiene otra clase/id)
    const headerEl =
      document.querySelector(".top-nav") ||
      document.querySelector("header") ||
      document.querySelector("#navbar") ||
      null;
  
    const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 80; // fallback 80px
    const extraOffset = 12; // ajuste fino (margen)
    const top = window.scrollY + el.getBoundingClientRect().top - headerHeight - extraOffset;
  
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  
    // opcional: marcar como activa (para cambiar estilo)
    setActiveCategory(slug);
  };


  // Arreglo de animaciones disponibles
const animacionesDisponibles = [
  lineasblancasvolando,
  efectoparticulas,
  fuegoamarillo,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  neutron,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  fuegorojo,
  fuegoamarillo,
];

  const [mostrarAnimacion, setMostrarAnimacion] = useState(true);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  const [denegado, setDenegado] = useState(false);

  const [varianteSeleccionada, setVarianteSeleccionada] = useState('AZUL | ROSA');

  //const descuento = Math.round(((precioAnterior - precioActual) / precioAnterior) * 100);
  const [datosProducto, setDatosProducto] = useState(null);
  const [imagenes, setImagenes] = useState([]);
  const [imagenSeleccionada, setImagenSeleccionada] = useState("");
  const [precioActual, setPrecioActual] = useState(0);
  const [precioAnterior, setPrecioAnterior] = useState(0);
  const [descuento, setDescuento] = useState(0);
  
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [cantidadSeleccionada, setCantidadSeleccionada] = useState(1);
  const [mostrarAgotado, setMostrarAgotado] = useState(false);

  const [cantidad, setCantidad] = useState(1);

  const [tipoVarianteSeleccionada, setTipoVarianteSeleccionada] = useState("");

const [coloresGlobales, setColoresGlobales] = useState({});

const [modoVista, setModoVista] = useState("imgs"); // al principio está en imágenes


// Añadir cerca de tus otros useState
const [visualesOrdenados, setVisualesOrdenados] = useState([]); // array de urls en orden
const [visualesMap, setVisualesMap] = useState({}); // { url: { orden, tipo, url } } para búsqueda rápida

// TTL del cache en ms (ej. 30 minutos)
const CACHE_TTL_MS = 1000 * 60 * 30;

const saveCache = (key, data) => {
  try {
    const payload = { ts: Date.now(), data };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (e) {
    // localStorage puede llenarse; ignorar errores silenciosamente
    console.warn("saveCache fallo para", key, e);
  }
};

const loadCache = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (!ts || Date.now() - ts > CACHE_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch (e) {
    console.warn("loadCache fallo para", key, e);
    return null;
  }
};

const clearCacheKey = (key) => {
  try { localStorage.removeItem(key); } catch(e) {}
};
/////////////////////////////////////////////////////////////////////////////////////////

// Para escuchar cambios en modoVista y en itemSeleccionado
//Cada vez que cambie modoVista (por ejemplo, al volver de 3D a "imgs") o que cambie el itemSeleccionado, este useEffect verifica si está en modo imgs.
useEffect(() => {
  if (
    modoVista === 'imgs' &&
    tipoVarianteSeleccionada?.toLowerCase() === 'color' &&
    itemSeleccionado?.Nombre
  ) {
    const nombreColorNormalizado = itemSeleccionado.Nombre
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, '');

    const imagenRelacionada = imagenes.find(img =>
      img.toLowerCase().includes(nombreColorNormalizado)
    );

    if (imagenRelacionada) {
      setImagenSeleccionada(imagenRelacionada);
    }
  }
}, [modoVista, itemSeleccionado, tipoVarianteSeleccionada, imagenes]);


// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};
// 🔹 Obtener carrito al cargar la página
useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
}, []);
//////////////////////////////////////////////////////////////////////

//Codigo para cargar categorias
useEffect(() => {
  let abort = false;
  async function cargarCategorias() {
    // 1️⃣ Intentar cargar desde cache
    const key = "categoriasAwoo_v2";
    const fromCache = loadCache(key);
    if (fromCache) {
      setCategorias(fromCache);
      // no return: también lanzamos una actualización en background para refrescar si hay cambios opcional.
    }

    try {
      const db = getDatabase(app);
      const categoriasRef = ref(db, "nature/Awoo/Categorias");
      const snapshot = await get(categoriasRef);
      if (!snapshot.exists()) return;
      if (abort) return;

      const categoriasData = snapshot.val();
      const categoriasArray = Object.keys(categoriasData);
      const resultado = [];

      for (const categoria of categoriasArray) {
        if (abort) break;
        const visibleSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
        const visible = visibleSnapshot.exists() ? visibleSnapshot.val().toLowerCase() : "no";
        if (visible !== "si") continue;

        const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
        const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";

        // Intentamos cachear la imagen (esto puede tardar) — lo hacemos no bloqueo
        let imgCached = imgUrl || "";
        if (imgUrl) {
          cacheImage(imgUrl, "cat_" + categoria).then((u) => {
            // actualizamos estado y cache cuando termine
            setCategorias((prev) => {
              if (!prev) return prev;
              const updated = prev.map((c) => (c.nombre === categoria ? { ...c, img: u || imgUrl } : c));
              saveCache(key, updated);
              return updated;
            });
          }).catch(()=>{});
        }

        resultado.push({ nombre: categoria, img: imgCached });
      }

      const mezcladas = resultado.sort(() => 0.5 - Math.random());
      if (!abort) {
        setCategorias(mezcladas);
        saveCache(key, mezcladas);
      }
    } catch (err) {
      if (!abort) console.error("Error cargando categorias:", err);
    }
  }

  cargarCategorias();
  return () => { abort = true; };
}, []);

////////////// Datos del producto
useEffect(() => {
  if (!categoriaid || !productoid) return;

  const db = getDatabase(app);
  const productoRef = ref(db, `nature/Awoo/Categorias/${categoriaid}/${productoid}`);

  get(productoRef).then((snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      setDatosProducto(data);

      // Precios y descuento
      const precio = data.Precio || 0;
      const precioAnt = data.PrecioAnterior || 0;
      setPrecioActual(precio);
      setPrecioAnterior(precioAnt);
      const desc = precioAnt ? Math.round(100 - (precio * 100) / precioAnt) : 0;
      setDescuento(desc);

      // Visuales (ordenados por "orden")
      // Dentro del useEffect que obtiene datos del producto
const visuales = data.Visuales || {};
// Convertir a array ordenado y extraer sólo urls
const listaVisualesEstruct = Object.values(visuales)
  .filter(v => v.tipo === "imagen")
  .sort((a, b) => a.orden - b.orden);

// lista de urls en orden
const listaVisuales = listaVisualesEstruct.map(v => v.url);

// crear un map para búsquedas rápidas (por url y por nombre base de archivo)
const mapVis = {};
listaVisualesEstruct.forEach(v => {
  mapVis[v.url] = v;
  try {
    // también indexar por nombre de archivo decodificado (por si guardaste solo nombres en variantes)
    const decoded = decodeURIComponent(v.url);
    const match = decoded.match(/%2F([^\/?]+)\?/); // intenta extraer segmento del nombre
    if (match && match[1]) mapVis[match[1]] = v;
  } catch (e) {
    // ignore
  }
});

setVisualesOrdenados(listaVisuales);
setVisualesMap(mapVis);

// Mantener la lógica de selección inicial de imagenes como antes:
if (data.Img) {
  setImagenSeleccionada(data.Img);
  setImagenes([data.Img, ...listaVisuales.filter(url => url !== data.Img)]);
} else if (listaVisuales.length > 0) {
  setImagenSeleccionada(listaVisuales[0]);
  setImagenes(listaVisuales);
}

    }



  });
}, [categoriaid, productoid]);
///Este useeffect reinicia los valores de Variable y Contador
useEffect(() => {
  setItemSeleccionado(null);
  setCantidadSeleccionada(1);
}, [productoid]);
// Resolver una referencia que venga en item.Imagenes (puede ser URL completa, nombre, o fragmento)
const resolverReferenciaImagen = (refString) => {
  if (!refString) return null;
  // si ya es URL completa
  if (typeof refString === 'string' && refString.startsWith('http')) return refString;

  // buscar directo en el map por key exacta (puede ser url guardada o nombre de archivo)
  if (visualesMap[refString]) return visualesMap[refString].url;

  // intentar coincidencia parcial (por ejemplo: nombre "blanco" o fragmento del archivo)
  const keyLower = String(refString).toLowerCase();
  for (const k of Object.keys(visualesMap)) {
    const v = visualesMap[k];
    if (!v || !v.url) continue;
    if (v.url.toLowerCase().includes(keyLower)) return v.url;
  }

  // no se resolvió
  return null;
};
// ✅ Cambia las imágenes mostradas cuando se selecciona una variante
useEffect(() => {
  // si no hay producto cargado, nada
  if (!datosProducto) return;

  // Si existe item seleccionado y tiene Imagenes asignadas -> mostrar sólo esas
  if (itemSeleccionado && Array.isArray(itemSeleccionado.Imagenes) && itemSeleccionado.Imagenes.length > 0) {
    // resolver cada referencia y filtrar nulos
    const resolved = itemSeleccionado.Imagenes
      .map(refImg => resolverReferenciaImagen(refImg) || refImg) // si no se resuelve, mantener lo que venga
      .filter(Boolean);

    if (resolved.length > 0) {
      setImagenes(resolved);
      setImagenSeleccionada(resolved[0]);
      return;
    }
  }

  // Si no hay itemSeleccionado con imágenes -> mostrar Visuales por defecto (ordenados)
  if (visualesOrdenados && visualesOrdenados.length > 0) {
    setImagenes(visualesOrdenados);
    // mantener la imagen seleccionada previa si sigue en la lista, si no, tomar la primera
    setImagenSeleccionada(prev => (visualesOrdenados.includes(prev) ? prev : visualesOrdenados[0]));
  } else {
    // caso borde: no hay visuales guardados
    setImagenes([]);
    setImagenSeleccionada(null);
  }
}, [itemSeleccionado, datosProducto, visualesOrdenados]);



/// Item seleccionado en VARIANTES
useEffect(() => {
  if (!datosProducto?.Variantes) return;


 // for (const [_, listaItems] of Object.entries(datosProducto.Variantes)) {
 //   const items = Object.values(listaItems);
 //   if (items.length === 1) {
 //     setItemSeleccionado(items[0]);
 //     setCantidadSeleccionada(1);
 //     break;
 //   }
 // }




}, [datosProducto]);
/// Muestra AGOTADO si no existen más cantidades
useEffect(() => {
  if (!datosProducto?.Variantes) return;
  const todasVariantes = Object.values(datosProducto.Variantes).flatMap(grupo =>
    Object.values(grupo)
  );
  const hayAlMenosUnaConStock = todasVariantes.some(item => item.Cantidad > 0);
  setMostrarAgotado(!hayAlMenosUnaConStock);
}, [datosProducto]);
////////////////////////////



/////// Detecta cunado el usuario presiona ATRAS y redirige
useEffect(() => {
  const handlePopState = (event) => {
    navigate("/awooproductosusuario", {
      state: { categoria: categoriaid, producto: productoid, mesa },
      replace: true,
    });
  };

  window.addEventListener("popstate", handlePopState);

  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
}, [categoriaid, productoid, mesa, navigate]);
//////////////////////////



////// Hacer scroll arriba cuando cambie el producto
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // o "auto" si no quieres animación
  }, [productoid]);
//////////////////////


//////////////////////////////////////////////////////////////////////
// Categoria - Lista de Productos
useEffect(() => {
  if (!categoriaid || !productoid) return;

  const db = getDatabase(app);
  const productosRef = ref(db, `nature/Awoo/Categorias/${categoriaid}`);

  get(productosRef).then((snapshot) => {
    if (snapshot.exists()) {
      const productosData = snapshot.val();

      const listaProductos = Object.keys(productosData)
        .filter((key) => key !== productoid) // ← EXCLUIR el producto actual
        .map((key) => ({
          id: key,
          ...productosData[key],
        }));

      // Mezclar aleatoriamente la lista
      const listaAleatoria = listaProductos.sort(() => 0.5 - Math.random());

      // Tomar solo los primeros 6
      const seisProductos = listaAleatoria.slice(0, 6);

      setProductos(seisProductos);
    }
  });
}, [categoriaid, productoid]); // ← Asegúrate de incluir "producto" en el array de dependencias

  
////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
////////////////////////


//////////////////////////////

useEffect(() => {
  window.onColorChangeStl = (nuevoColor) => {
    if (!datosProducto?.Variantes?.Color) return;
    const match = Object.values(datosProducto.Variantes.Color).find(item => item.Nombre === nuevoColor.name);
    if (match) {
      setItemSeleccionado(match);
      setTipoVarianteSeleccionada('Color');
    }
  };

  // Al montar: si hay color guardado, aplicarlo
  const colorGuardado = JSON.parse(localStorage.getItem("colorSeleccionado"));
  if (colorGuardado && datosProducto?.Variantes?.Color) {
    const match = Object.values(datosProducto.Variantes.Color).find(item => item.Nombre === colorGuardado.name);
    if (match) {
      setItemSeleccionado(match);
      setTipoVarianteSeleccionada('Color');
    }
  }

  return () => {
    window.onColorChangeStl = null;
  };
}, [datosProducto]);
//////////////////////


//////////////////
useEffect(() => {
  const db = getDatabase(app);
  const colorRef = ref(db, 'nature/Awoo/Control/SimuladorStl/ColoresPlastico');
  get(colorRef).then(snapshot => {
    if (snapshot.exists()) {
      setColoresGlobales(snapshot.val());
    }
  });
}, []);
////////////////


///////////////
//sincroniza itemSeleccionado desde localStorage al inicio de 3dfyrionvista.js por si se recarga la página:
useEffect(() => {
  const handler = () => {
    const colorGuardado = JSON.parse(localStorage.getItem("colorSeleccionado"));
    if (!colorGuardado) return;

    const variantesColor = datosProducto?.Variantes?.Color;
    if (variantesColor) {
      const itemMatch = Object.values(variantesColor).find(i => i.Nombre === colorGuardado.name);
      if (itemMatch) {
        setItemSeleccionado(itemMatch);
        setCantidadSeleccionada(1);
        setTipoVarianteSeleccionada("Color");
      }
    }
  };

  // Ejecuta al montar el componente
  handler();

  // También re-ejecuta si el evento de cambio se dispara
  window.addEventListener("color-stl-cambiado", handler);

  return () => {
    window.removeEventListener("color-stl-cambiado", handler);
  };
}, [datosProducto]);
///////////

const seccionResenasRef = useRef(null);
const hacerScrollAResenas = () => {
  seccionResenasRef.current?.scrollIntoView({ behavior: "smooth" });
};



  // Función para navegar a awoovistaitem.js
  const verProducto = (producto) => {
    navigate("/3dfyrionvista", {
      state: { categoria: categoriaid, producto, mesa }, // Enviamos categoría y producto
      replace: true, // Reemplaza en lugar de apilar en el historial
    });
  };


  if (!animacionSeleccionada) return null; // Muestra nada mientras se selecciona la animación
////////////////////////////////////////////////////////////////////////////////////


////////////////// 🚫 Si el acceso está denegado, solo muestra el AlertDialog
  // 🔹 Función para guardar en localStorage
  const guardarCarrito = (nuevoCarrito) => {
    localStorage.setItem("carrito", JSON.stringify(nuevoCarrito));
  };

  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };


  // 🔹 Función para agregar al carrito
  const agregarAlCarrito = () => {
    if (!validarSeleccion()) {
      return;
    }
    
  
    let carrito = obtenerCarrito();
  
    const idVariante = itemSeleccionado?.Nombre || "variante";
    const key = `${categoriaid}-${productoid}-${idVariante}`;
  
    const index = carrito.findIndex(item => item.key === key);
  
    let imagenUrl = datosProducto.Img;
    if (!imagenUrl && datosProducto.Visuales) {
      const visuales = Object.values(datosProducto.Visuales)
        .filter(v => v.tipo === "imagen")
        .sort((a, b) => a.orden - b.orden);
      if (visuales.length > 0) imagenUrl = visuales[0].url;
    }
  
    const productoAAgregar = {
      key,
      categoria: categoriaid,
      producto: productoid,
      cantidad: cantidadSeleccionada,
      Img: imagenUrl || "images/default.jpg",
      Titulo: datosProducto.Titulo,
      Descripcion: datosProducto.Descripción,
      Calificacion: datosProducto.Calificacion || "4.9",
      PrecioAnterior: datosProducto.PrecioAnterior,
      Precio: datosProducto.Precio,
      Costo: datosProducto.Costo,
      Tipovariante: tipoVarianteSeleccionada,
      variante: itemSeleccionado,
    };
  
    if (index !== -1) {
      carrito[index] = productoAAgregar;
      alert(`✅ Actualizado: ${productoid} (${idVariante})`);
    } else {
      carrito.push(productoAAgregar);
      alert(`✅ Añadido: ${productoid} (${idVariante})`);
    }
  
    guardarCarrito(carrito);
    setCarritoCantidad(carrito.length); // <- ¡esto actualiza el contador sin recargar!
  };
  // Función para comprar ahora
  const comprarAhora = () => { 
    if (!validarSeleccion()) {
     return;
   }

    let carrito = obtenerCarrito();
  
    const idVariante = itemSeleccionado?.Nombre || "variante";
    const key = `${categoriaid}-${productoid}-${idVariante}`;
  
    const index = carrito.findIndex(item => item.key === key);
  
    let imagenUrl = datosProducto.Img;
    if (!imagenUrl && datosProducto.Visuales) {
      const visuales = Object.values(datosProducto.Visuales)
        .filter(v => v.tipo === "imagen")
        .sort((a, b) => a.orden - b.orden);
      if (visuales.length > 0) imagenUrl = visuales[0].url;
    }
  
    const productoAAgregar = {
      key,
      categoria: categoriaid,
      producto: productoid,
      cantidad: cantidadSeleccionada,
      Img: imagenUrl || "images/default.jpg",
      Titulo: datosProducto.Titulo,
      Descripcion: datosProducto.Descripción,
      Calificacion: datosProducto.Calificacion || "4.9",
      PrecioAnterior: datosProducto.PrecioAnterior,
      Precio: datosProducto.Precio,
      Costo: datosProducto.Costo,
      Tipovariante: tipoVarianteSeleccionada,
      variante: itemSeleccionado,
    };
  
    if (index !== -1) {
      carrito[index] = productoAAgregar;
    } else {
      carrito.push(productoAAgregar);
    }
  
    guardarCarrito(carrito);
    navigate("/3dfyrionresumen", { state: { mesa } });
  };
  

  const handleAgregarClick = () => {
    if (!itemSeleccionado) {
      alert(`Debes seleccionar primero un ${tipoVarianteSeleccionada || "atributo"}`);
      return;
    }
    agregarAlCarrito();
  };
  
  const handleComprarClick = () => {
    if (!itemSeleccionado) {
      alert(`Debes seleccionar primero un ${tipoVarianteSeleccionada || "atributo"}`);
      return;
    }
    comprarAhora();
  };
  


  // Función para validar la selección de Variante
  const validarSeleccion = () => {
    if (!itemSeleccionado) {
      alert("⚠️ Debes seleccionar una variante.");
      return false;
    }
    if (itemSeleccionado.Cantidad < cantidadSeleccionada) {
      alert("⚠️ No hay suficiente stock disponible.");
      return false;
    }
    return true;
  };
  


  return (
<div style={{ display: 'flex', flexDirection: 'column',  width:'100%', overflowX: "hidden", background: 'white', position: 'relative'}}>

  {/* Contenido deslizable */}
  <div
    style={{
      flex: 1, // Esto asegura que ocupe todo el espacio disponible arriba de la barra
    }}
  >
    {/* Aquí va todo el contenido deslizable */}
    <div style={{ width:'100%'}}>


{/* ------------------ BARRA LATERAL ------------------------ */}
<motion.div
  initial={{ x: "-100%" }}
  animate={{ x: menuAbierto ? 0 : "-100%" }}
  transition={{ duration: 0.3, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    zIndex: 9999,
    padding: "20px",
    boxShadow: "4px 0 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  }}
>
  {/* Botón cerrar */}
  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      onClick={() => setMenuAbierto(false)}
      style={{
        background: "none",
        border: "none",
        color: "white",
        fontSize: "26px",
        cursor: "pointer",
      }}
    >
      ✖
    </button>
  </div>

  {/* Opciones principales */}
  <div style={{ marginTop: "10px", marginBottom: "20px" }}>
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
      <div
        key={opcion}
        onClick={() => {
          if (opcion === "INICIO") navigate("/");
          if (opcion === "PRODUCTOS") navigate("/3dfyrioninicioproductos");
          if (opcion === "SIMULADORES") navigate("/3dfyrioninicionosotros");
          setMenuAbierto(false);
        }}
        style={{
          padding: "12px 0",
          paddingLeft: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: "pointer",
          borderBottom: "1px solid #333",
        }}
      >
        {opcion}
      </div>
    ))}
  </div>

  {/* Categorías visibles */}
  <div style={{ marginTop: "10px" }}>
    <h3 style={{ fontSize: "14px", color: "#bbb", marginBottom: "10px" }}>
      CATEGORÍAS
    </h3>

    {categorias.map((cat, index) => (
      <div
        key={index}
        onClick={() => {
          handleCategoriaClick(cat.nombre);
          setMenuAbierto(false);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0",
          cursor: "pointer",
          borderBottom: "1px solid #222",
          gap: "10px",
        }}
      >
        <img
          src={cat.img}
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "6px",
            objectFit: "cover",
          }}
        />
        <span style={{ fontSize: "15px" }}>{cat.nombre}</span>
      </div>
    ))}
  </div>
</motion.div>

{/* Fondo oscuro cuando menú está abierto */}
{menuAbierto && (
  <div
    onClick={() => setMenuAbierto(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9998,
    }}
  ></div>
)}
{/* ---------------------------------------------------------- */}


  {/* Encabezado */}
  <div
      style={{
        width: "100%",
        height: "70px",
        backgroundColor: "#111",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Lado izquierdo - botón de menú y logo + lupa */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginLeft: "15px",
        }}
      >
        
      {/* <FaBars size={35} style={{ cursor: "pointer" }} /> */}
      <FaBars 
  size={35} 
  style={{ cursor: "pointer" }} 
  onClick={() => setMenuAbierto(true)}
/>

        
        <img
          src="images/dragonfondo2.png"
          alt="Logo"
          style={{
            height: "75px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        <FaSearch
          size={20}
          style={{ cursor: "pointer" }}
          onClick={toggleBusqueda}
        />
      </div>

      {/* Centro - barra de búsqueda */}
      {mostrarBusqueda && (
        <input
          type="text"
          placeholder="Buscar..."
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50%",
            height: "35px",
            borderRadius: "8px",
            padding: "0 15px",
            border: "none",
            outline: "none",
            fontSize: "16px",
          }}
        />
      )}

      {/* Lado derecho - carrito + contador + perfil */}
{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      position: "relative",
      width: "48px",
      cursor: "pointer",
      marginRight:"19px"
    }}
  >
    <div
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        border: "3px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "45%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 5px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}
    </div>




      {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
      }}
    >
    </div>

    <div
    style={{
      position: 'relative', // Asegura que el contenido esté en una capa superior
      width:'100%'
    }}
  >
    {/* Animación*/}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // Alinea los elementos en los extremos
        alignItems: "center", // Centra verticalmente
        width: "100%", // Usa todo el ancho disponible
        padding: "10px", // Espaciado interno
        position: "relative", // Mantiene posiciones relativas
      }}
    >
      {/* --- Logo y Animación --- */}
      <div
        style={{
          marginLeft: "12px",
          display: "flex",
          alignItems: "center", // Centra verticalmente
          position: "relative",
        }}
      >
<Lottie
  animationData={animacionSeleccionada}
  play
  loop
  style={{
    position: "absolute",
    width: "350px",
    height: "350px",
    top: "-30px",
    left: window.innerWidth < 768 ? "0px" : "-50px",
    zIndex: 5,
    pointerEvents: "none",
  }}
/>
      </div>
    </div>




{/* Ficha Técnica Producto */}
<div style={{ width: '100%', padding: '5px', boxSizing: 'border-box' }}>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
{/* Galería de Imágenes */}
<div style={{ 
  flex: '1 1 350px', 
  padding: "1px", 
  minHeight: modoVista === 'imgs' ? '500px' : '50px', 
  overflow: 'auto' // Para permitir desplazamiento si es necesario
}}>

{datosProducto && (
  <VisorProducto
    imagenes={imagenes}
    imagenSeleccionada={imagenSeleccionada}
    setImagenSeleccionada={setImagenSeleccionada}
    categoria={categoriaid}
    producto={productoid}
    linkstl={datosProducto.STL} // solo se usa si ya se cargó
    modoVista={modoVista}
    setModoVista={setModoVista}
    coloresGlobales={coloresGlobales}
    setItemSeleccionado={setItemSeleccionado}
    setTipoVarianteSeleccionada={setTipoVarianteSeleccionada}
    datosProducto={datosProducto}
  />
)}



</div>
{/* Información del Producto */}
<div style={{ 
  flex: '1 1 150px', 
  maxWidth: '700px', 
  minWidth: '300px', 
  width: '100%', 
}}>

  <h1 style={{ fontSize: '35px', marginBottom: '10px' }}>{datosProducto?.Titulo}</h1>
  <ResumenResenas
  categoria={categoriaid}
  producto={productoid}
  onClick={hacerScrollAResenas}
/>


  {/* Precios Centrados */}
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
    <span style={{ textDecoration: 'line-through', color: '#575758' }}>
      ${precioAnterior.toLocaleString('es-CO')}
    </span>
    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
      ${precioActual.toLocaleString('es-CO')}
    </span>
    <span style={{ backgroundColor: '#b016b5', color: '#fff', padding: '2px 6px', borderRadius: '4px' }}>
      -{descuento}% OFF
    </span>
  </div>

{/* Selección de Variantes */}
{Object.entries(datosProducto?.Variantes || {}).map(([nombreTipo, listaNumerica], tipoIdx) => (
  <div key={tipoIdx} style={{ marginBottom: '20px' }}>
    <h3 style={{ marginBottom: '10px' }}>✔️ {nombreTipo} (Disponible(s))</h3>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
      {Object.values(listaNumerica || {}).map((item, itemIdx) => {
        const isSelected = item?.Nombre === itemSeleccionado?.Nombre && tipoVarianteSeleccionada === nombreTipo;
        const agotado = item.Cantidad === 0;
        const colorHex = nombreTipo.toLowerCase() === "color" && coloresGlobales[item.Nombre]
          ? `#${coloresGlobales[item.Nombre]}`
          : null;

        return (
          <div
            key={itemIdx}
            onClick={() => {
              if (!agotado) {
                setItemSeleccionado(item);
                setCantidadSeleccionada(1);
                setTipoVarianteSeleccionada(nombreTipo);

                if (modoVista === 'imgs' && nombreTipo.toLowerCase() === 'color') {
                  const nombreColorNormalizado = item.Nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '');
                  const imagenRelacionada = imagenes.find(img => img.toLowerCase().includes(nombreColorNormalizado));
                  if (imagenRelacionada) {
                    setImagenSeleccionada(imagenRelacionada);
                  }
                }                

                if (nombreTipo.toLowerCase() === "color" && colorHex) {
                  const colorFinal = { name: item.Nombre, hex: colorHex };
                  localStorage.setItem("colorSeleccionado", JSON.stringify(colorFinal));
                  if (typeof window.onColorChangeStl === 'function') {
                    window.onColorChangeStl(colorFinal);
                  }
                }
                
              }
            }}
            style={{
              padding: '10px 16px',
              borderRadius: '20px',
              cursor: agotado ? 'not-allowed' : 'pointer',
              backgroundColor: isSelected ? '#0bbfe3' : '#f0f0f0',
              color: agotado ? '#999' : '#000',
              border: `2px solid ${isSelected ? '#0bbfe3' : '#ccc'}`,
              opacity: agotado ? 0.5 : 1,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            {colorHex && (
              <span
                style={{
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  backgroundColor: colorHex,
                  border: '1px solid #999',
                  fontSize:'25px'
                }}
              />
            )}
            {item.Nombre}
          </div>
        );
      })}
    </div>
  </div>
))}






  {/* Contenedor vertical de botones */}
  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '30px',alignItems: 'center' }}>
    
    {/* Aviso de Agotado */}
    {mostrarAgotado && (
  <div style={{ borderRadius: '10px', overflow: 'hidden' }}>
    <button
      style={{
        width: '50%',
        backgroundColor: '#999',
        color: '#fff',
        padding: '10px 20px',
        border: 'none',
        fontSize: '16px',
        cursor: 'not-allowed',
        borderRadius: '10px'
      }}
      disabled
    >
      Agotado
    </button>
  </div>
)}


    {/* Botón de Cantidad con + y - */}
    {itemSeleccionado?.Cantidad > 0 && (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
    <div style={{
      backgroundColor: '#eee',
      borderRadius: '10px',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }}>
      <button
        onClick={() => setCantidadSeleccionada(prev => Math.max(prev - 1, 1))}
        style={{
          backgroundColor: '#57a710',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          padding: '8px 14px',
          fontSize: '18px',
          cursor: 'pointer'
        }}
      >
        -
      </button>
      <span style={{ minWidth: '30px', textAlign: 'center', fontSize: '16px' }}>
        {cantidadSeleccionada}
      </span>
      <button
        onClick={() => setCantidadSeleccionada(prev => Math.min(prev + 1, itemSeleccionado.Cantidad))}
        style={{
          backgroundColor: '#57a710',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          padding: '8px 14px',
          fontSize: '18px',
          cursor: 'pointer'
        }}
      >
        +
      </button>
    </div>
    <span style={{ fontSize: '14px', color: '#555' }}>
      (Stock disponible: {itemSeleccionado.Cantidad})
    </span>
  </div>
)}



    {/* Agregar al Carrito */}
    <div style={{ borderRadius: '10px', overflow: 'hidden', width: '90%' }}>
      <button
      onClick={handleAgregarClick}
      disabled={!itemSeleccionado || itemSeleccionado.Cantidad < 1}
        style={{
          width: '100%',
          backgroundColor: '#0bbfe3',
          color: '#fff',
          padding: '12px 30px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'not-allowed',
          fontSize: '18px',
          fontStyle:"bold",
          cursor: (!itemSeleccionado || itemSeleccionado.Cantidad < 1) ? 'not-allowed' : 'pointer' 
        }}

      >
        Agregar al Carrito
      </button>
    </div>

    {/* Botón de Compra */}
    <div style={{ borderRadius: '10px', overflow: 'hidden' , width: '90%'}}>
      <button
      onClick={handleComprarClick}
      disabled={!itemSeleccionado || itemSeleccionado.Cantidad < 1}
        style={{
          width: '100%',
          backgroundColor: '#57a710',
          color: '#fff',
          padding: '12px 30px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'not-allowed',
          fontSize: '18px',
          cursor: (!itemSeleccionado || itemSeleccionado.Cantidad < 1) ? 'not-allowed' : 'pointer' 
        }}
      >
        Comprar Ahora
      </button>
    </div>
  </div>

  {/* Descripción del Producto */}
  <div style={{ marginTop: '20px' }}>
  <h2>Descripción</h2>
  <div
    style={{
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      width: '100%',
      maxWidth: '100%',
    }}
  >
    <div
      style={{
        width: '100%',
      }}
      dangerouslySetInnerHTML={{
        __html: (datosProducto?.Descripción || "").replace(
          /<img/g,
          `<img style="max-width: 100%; height: auto; display: block; margin: 10px auto"`
        ),
      }}
    />
  </div>

</div>

  {/* Ficha Técnica */}
  <div style={{ marginTop: '20px' }}>
<h2>Ficha Técnica</h2>
  <div
    style={{
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      width: '100%',
      maxWidth: '100%',
    }}
  >
    <div
      style={{
        width: '100%',
      }}
      dangerouslySetInnerHTML={{
        __html: (datosProducto?.Ficha || "").replace(
          /<img/g,
          `<img style="max-width: 100%; height: auto; display: block; margin: 10px auto"`
        ),
      }}
    />
  </div>
</div>
</div>
      </div>
    </div>



{/* Título superior alineado a la izquierda */}
<div style={{ width: "90%", margin: "0", padding: "10px 0" , marginTop:"25px"}}>
  <div style={{ textAlign: "left", fontWeight: "bold", fontSize: "25px" }}>
    Podría interesarte:
  </div>
</div>
{/* -- CARDVIEWS Productos */}
<div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "5px 0",
      }}
    >
      <div 
        style={{
          width: "90%",
          borderRadius: "15px",
          padding: "15px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          maxWidth: "90%",
          overflow: "hidden",
        }}
      >
        {/* Contenedor de tarjetas con Grid */}
        <div 
          style={{ 
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "10px",
            justifyContent: "center",
            paddingBottom: "10px",
          }}
        >
          {/* Renderizar productos dinámicamente */}
          {productos
  .filter((producto) => producto.visibilidad === "Si")
  .map((producto) => {
    const tienePrecioAnterior =
      producto.PrecioAnterior !== null &&
      producto.PrecioAnterior !== undefined &&
      producto.PrecioAnterior !== 0;

    const porcentajeDescuento = tienePrecioAnterior
      ? Math.round(
          100 - (producto.Precio * 100) / producto.PrecioAnterior
        )
      : null;

    return (
      <div
        key={producto.id}
        onClick={() => verProducto(producto.Titulo)}
        style={{
          backgroundColor: "#fff",
          borderRadius: "15px",
          padding: "10px",
          textAlign: "center",
          border: "3px solid #02f2fa",
          boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
          cursor: "pointer",
          position: "relative", // ← importante para posicionar el label
        }}
      >
        {/* Imagen del producto */}
        <div style={{ position: "relative" }}>
        {(() => {
  let imagenUrl = producto.Img;

  if (!imagenUrl && producto.Visuales) {
    const visualesArray = Object.values(producto.Visuales)
      .filter((item) => item && item.tipo === "imagen")
      .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

    if (visualesArray.length > 0) {
      imagenUrl = visualesArray[0].url;
    }
  }

  return (
    <img
      src={imagenUrl || "images/default.jpg"}
      alt={producto.Titulo || "Producto"}
      style={{
        width: "100%",
        height: "180px",
        objectFit: "cover",
        borderRadius: "10%",
      }}
    />
  );
})()}

          {/* Etiqueta de descuento */}
          {tienePrecioAnterior && (
            <div
              style={{
                position: "absolute",
                bottom: "8px",
                left: "8px",
                backgroundColor: "#b016b5",
                color: "white",
                padding: "4px 8px",
                borderRadius: "8px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              -{porcentajeDescuento}% OFF
            </div>
          )}
        </div>

        {/* Título */}
        <div
          style={{
            color: "black",
            fontWeight: "bold",
            marginTop: "10px",
            height: "38px",
          }}
        >
          {producto.Titulo || ""}
        </div>

        {/* Precio anterior con tachado */}
        {tienePrecioAnterior && (
          <div
            style={{
              color: "#7c7c7c",
              fontSize: "15px",
              fontWeight: "bold",
              textDecoration: "line-through", // ← tachado
            }}
          >
            ${producto.PrecioAnterior.toLocaleString("es-CO")}
          </div>
        )}

        {/* Precio actual */}
        <div
          style={{
            marginTop: "5px",
            backgroundColor: "#57a710",
            color: "white",
            padding: "5px",
            borderRadius: "10px",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          ${producto.Precio?.toLocaleString("es-CO") || "0"}
        </div>
      </div>
    );
  })}

          
        </div>
      </div>
    </div>
    
    {/* Botón inferior alineado a la derecha */}
<div style={{ width: "90%", margin: "0", padding: "10px 0" }}>
  <div style={{ textAlign: "right" }}>
    <button
      style={{
        backgroundColor: "#8ac20b",
        color: "white",
        fontWeight: "bold",
        border: "none",
        borderRadius: "20px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "16px",
      }}
      onClick={() => console.log("Ver más clickeado")} // ← Puedes cambiar esto por la acción que desees
    >
      Ver Más
    </button>
  </div>
</div>




<div ref={seccionResenasRef}>
  <ResenasProducto categoria={categoriaid} producto={productoid} />
</div>




{/* Redes Sociales */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "55px",
    padding: "20px 0 10px 0",
    marginTop:"35px"
  }}
>
  <a
    href="https://www.google.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
      alt="Facebook"
      style={{ width: "35px", height: "35px", filter: "grayscale(100%)" }}
    />
  </a>

  <a
    href="https://www.google.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
      alt="Instagram"
      style={{ width: "35px", height: "35px", filter: "grayscale(100%)" }}
    />
  </a>

  <a
    href="https://www.google.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/3046/3046122.png"
      alt="TikTok"
      style={{ width: "35px", height: "35px", filter: "grayscale(100%)" }}
    />
  </a>
</div>

{/* Nombre de usuario */}
<div
  style={{
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#333",
    marginBottom: "15px",
  }}
>
  @3dfyrion
</div>

{/* Footer */}
<div
  style={{
    width: "100%",
    padding: "15px 0",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
    borderTop: "1px solid #ccc",
  }}
>
  <span style={{ fontSize: "16px", marginRight: "5px" }}>©</span>
  2025, 3dFyrion Colombia | Tecnología y Diseño de 3dfyrion
</div>




      </div>

    </div>

  </div>

 
</div>
    );
  }
  
  export default PantallaPrincipal;
  